export default "__VITE_ASSET__Cmt5QsZN__"